import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Button from '../button';
import Typography from '../typography';
import { Divider, Drawer, Toolbar } from '@mui/material';
import Box from '../box';
import { NavbarText } from '../../constants/text';
import { NavLink } from 'react-router-dom';
import useIsAuthenticated from '../../hooks/useIsAuthenticated';
import useCurrentUserId from '../../hooks/useCurrentUserId';
import IconButton from '../icon_button';
import MenuIcon from '@mui/icons-material/Menu';

const NavButton: React.FC<{ text: string, to: string, external?: boolean }> = ({
  text,
  to,
  external
}) => {
  if (external) {
    return (
      <a style={{
        textDecoration: 'none',
        color: 'white',
        display: 'block'
      }}
      target='_blank'
      href={to} rel="noreferrer"
      >
        <Button color="inherit" fullWidth>
          {text}
        </Button>
      </a>
    )
  }

  return (
    <NavLink
      style={{
        display: 'block',
        textDecoration: 'none',
        color: 'white'
      }}
      to={to}
    >
      {({ isActive }) => (

        <Button fullWidth color={isActive ? 'info' : 'inherit'}>
          {text}
        </Button>
      )}
    </NavLink>
  )
}

const RightNavigations: React.FC = () => {
  const isAuthenticated = useIsAuthenticated()
  const userId = useCurrentUserId()
  const navButtons = React.useMemo(() => {
    const commonNav = (
      <>
        <NavButton text="Support" external to="https://trystate.notion.site/Hey-there-Need-help-0527b5043cd446afb51316f1e5e174c8" />
      </>
    )

    if (isAuthenticated) {
      return (
        <>
          <NavButton text={'Add Studio'} to="/studio-listings/add" />
          <NavButton text={'Bookings'} to="/bookings" />
          {commonNav}
          <NavButton text={'Profile'} to={`/profile/${userId as string}`} />
          <NavButton text="Settings" to="/settings/profile" />
          <NavButton text="Logout" to="/auth/logout" />
        </>
      )
    }
    return (
      <>
        <NavButton text={'Add Studio'} to="/studio-listings/add" />
        <NavButton text={NavbarText.LOGIN_BUTTON} to="/auth/login" />
        <NavButton text={NavbarText.REGISTER_BUTTON} to="/auth/signup" />
        {commonNav}
      </>
    )
  }, [isAuthenticated, userId])

  return navButtons
}

const Navbar: React.FC = () => {
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = async (): Promise<void> => {
    setMobileOpen(!mobileOpen)
  }

  return (
    <Box>
      <Box sx={{ flexGrow: 1, alignItems: 'center' }}>
        <AppBar color='transparent' position="static" component={'nav'}>
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2, display: { md: 'none' }, color: 'white' }}
            >
              <MenuIcon />
            </IconButton>

            <NavLink to={'/'} style={{
              textDecoration: 'none',
              color: 'inherit'
            }}>
              <Typography
              variant="h6"
              noWrap
              sx={{ display: { sm: 'block' } }}
            >
                {NavbarText.TITLE}
              </Typography>
            </NavLink>
            <Box sx={{ flexGrow: 1 }} />
            <Box sx={{
              display: { xs: 'none', md: 'flex' },
              flexDirection: 'row'
            }}>
              <RightNavigations />
            </Box>
          </Toolbar>
        </AppBar>
      </Box>
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true // Better open performance on mobile.
        }}
        sx={{
          display: { xs: 'block', sm: 'none' },
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: 240 }
        }}
        >
        <Box sx={{
          display: 'flex',
          flexDirection: 'column'
        }}>
          <Typography mt={2} textAlign={'center'}>
            {NavbarText.TITLE}
          </Typography>
          <Divider sx={{ mt: 1, mb: 2 }} />
          <RightNavigations />
        </Box>
      </Drawer>
    </Box>
  );
}

export default Navbar
